@if (!isLogin && !isChangePassword && !isRegistration) {
  <div class="bg-mesh"></div>
  <div class="bg-grain"></div>

  @if (authSession.isAuthenticated()) {
    <app-header></app-header>
  }
}

@if (spinnerService.isLoading()) {
  <div class="spinner-backdrop" aria-live="polite" aria-busy="true">
    <div class="app-spinner" aria-label="Caricamento"></div>
  </div>
}

<app-toast-host></app-toast-host>
<router-outlet></router-outlet>
